export const defaultValues = {
  regionalId: null,
  requestDate: new Date(),
  chargeRequestedId: null,
  processId: null,
  requestUser: null,
  chargeApplicantId: null,
  amount: 0,
  replaceUser: null,
  retirementReason: null,
  requestReason: null,
  retirementDate: null,
  admissionDate: null,
  contractType: null,
  observations: null,
};

export const defaultSearchValues = {
  firstName: null,
  lastName: null,
  regional: null,
  initDate: null,
  endDate: null,
  status: null,
};

export const headers = {
  initialHeaders: [
    { title: "FECHA DE SOLICITUD", field: "requestDate", child: null },
    {
      title: "NOMBRE DEL EMPLEADO",
      field: "employeeRequesting",
      child: "fullName",
    },
    { title: "REGIONAL", field: "employeeRequesting", child: "regional" },
    { title: "ESTADO", field: "status", child: null },
  ],
  otherHeaders: [
    { title: "PRIMER NOMBRE", field: "employeeRequesting", child: "firstName" },
    {
      title: "SEGUNDO NOMBRE",
      field: "employeeRequesting",
      child: "secondName",
    },
    {
      title: "PRIMER APELLIDO",
      field: "employeeRequesting",
      child: "surname",
    },
    {
      title: "SEGUNDO APELLIDO",
      field: "employeeRequesting",
      child: "secondSurname",
    },
    {
      title: "TIPO DE DOCUMENTO",
      field: "documentType",
      child: null,
    },
    {
      title: "NÚMERO DE DOCUMENTO",
      field: "employeeRequesting",
      child: "document",
    },
    {
      title: "CARGO SOLICITANTE",
      field: "employeeRequesting",
      child: "charge",
    },
    { title: "DURACIÓN DEL PERMISO", field: "numberDay", child: null },
    { title: "TIPO DE PERMISO", field: "permissionType", child: null },
    { title: "DESCRIPCIÓN", field: "permissionTypeOtherDescription", child: null },
    {
      title: "FECHA DE INICIO",
      field: "permitStarDate",
      child: null,
    },
    {
      title: "FECHA DE FINALIZACIÓN",
      field: "permitEndDate",
      child: null,
    },
    {
      title: "REMUNERACIÓN",
      field: "paid",
      child: null,
    },
    {
      title: "REGIONAL",
      field: "employeeApprover",
      child: "regional",
    },
  ],
};

export const amountValues = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
];
